import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * The frosted card of the slide visuals: it blurs the stage (and the torus)
 * behind it.
 */
export function GlassCard({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        'rounded-2xl border border-white/[.14] shadow-[0_30px_60px_-30px_rgba(0,0,0,0.6)] backdrop-blur-[14px]',
        className
      )}
      style={{
        background:
          'linear-gradient(rgba(255,255,255,0.07), rgba(255,255,255,0.04)), rgba(10,18,42,0.5)',
      }}
    >
      {children}
    </div>
  );
}
